import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=044ac969"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"
import style0 from "./Links.vue?vue&type=style&index=0&id=044ac969&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports